import { useAthosContext } from 'libs/athos/fetchers/provider'

export function calculateProductCount(results) {
  const apiTotalResults = results?.pagination?.totalResults || 0
  const totalBanners = (results?.merchandising?.content?.inline?.length || 0) + (results?.merchandising?.content?.header?.length || 0) + (results?.merchandising?.content?.footer?.length || 0) + (results?.merchandising?.content?.banner?.length || 0)
  return Math.max(0, apiTotalResults - totalBanners)
}

export function ProductCount() {
  const { results } = useAthosContext()
  const totalResults = calculateProductCount(results)

  return (
    <div className="text-xs lg:text-s text-type-black-secondary">
      {totalResults === 0
        ? 'No Products'
        : totalResults === 1
          ? '1 Product'
          : `${totalResults.toLocaleString()} Products`}
    </div>
  )
}
